import { useContext } from 'react';

import { InputWithIcons } from 'src/components/Inputs';
import { InputContext } from 'src/contexts/input.context';
import { mockFn } from 'src/tools/fn.tools';

export function StringInput() {
  const {
    classNames,
    value,
    onChange,
    onSubmit = mockFn,
    onDiscard = mockFn,
    isDisabled,
    isAutoFocus,
    onClick,
    customization,
    placeholder,
    max,
  } = useContext(InputContext);

  return (
    <InputWithIcons
      className={classNames?.input}
      value={value}
      onChange={onChange}
      onSubmit={onSubmit}
      onDiscard={onDiscard}
      isDisabled={isDisabled}
      onClick={onClick}
      autoFocus={isAutoFocus}
      placeholder={placeholder}
      isXSmall={customization?.isXSmall}
      maxLength={max}
    />
  );
}
